import axios from '@/utils/request'

export default {
  // 2020-07-30
  findByTenantId() {
    return axios.get('/labels/find-by-tenant-id')
  },
  // 2020-07-30
  update(id, params) {
    return axios.put('/labels/' + id, params)
  },
  // 2020-07-30
  insertBatch(params) {
    return axios.post('/labels/insert-batch', params)
  },
  // 2020-07-30
  delete(id) {
    return axios.delete('/labels/' + id)
  },
  // 2021-03-16
  swapSequence(params) {
    return axios.put('/labels/swap-sequence', params)
  },
  // 2020-12-21
  findAllGroups(params) {
    return axios.get('/labels/find-all-groups', params)
  },
  // 2020-12-21
  batchUpdateGroup(params) {
    return axios.put('/labels/batch-update-group', params)
  },
  // 2020-12-21
  findAllSortByGroup() {
    return axios.get('/labels/find-all-sort-by-group')
  },

}

